/** The reserved per-user memory doc name — addressable only via the per-user (user-docs) path. */
export const PROTECTED_USER_DOC_NAME = 'USER.md';
/**
 * Whether a document is the reserved per-user doc, matched case-insensitively (and trimmed) so a casing
 * variant like `user.md` can't slip past guards.
 */
export const isProtectedUserDoc = (documentName) => documentName.trim().toLowerCase() === PROTECTED_USER_DOC_NAME.toLowerCase();
//# sourceMappingURL=oiq-user-docs.types.js.map